import { render, staticRenderFns } from "./editCashBoxesOpeningBalance.vue?vue&type=template&id=548ae0c8"
import script from "./editCashBoxesOpeningBalance.vue?vue&type=script&lang=js"
export * from "./editCashBoxesOpeningBalance.vue?vue&type=script&lang=js"
import style0 from "./editCashBoxesOpeningBalance.vue?vue&type=style&index=0&id=548ae0c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports